import { render, staticRenderFns } from "./dialog-forgot-password.vue?vue&type=template&id=c608bc64&"
import script from "./dialog-forgot-password.vue?vue&type=script&lang=js&"
export * from "./dialog-forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports